import { render, staticRenderFns } from "./BasketAddPopover.vue?vue&type=template&id=257178de&"
import script from "./BasketAddPopover.vue?vue&type=script&lang=js&"
export * from "./BasketAddPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports